module.exports = __webpack_public_path__ + "img/West-Mermis-Case-Study-600px.8c0a4b3c.jpeg";